export default __webpack_public_path__ + "static/ArtofChickenMeal-4f3b57abaf07bc85075ca9b171ae7768.webp";